/**
* ComebackController
* @namespace gplans.layout.controllers
*/
(function () {
  'use strict';ComebackController.$inject = ["$rootScope", "$state", "$stateParams", "Authentication", "$window", "$analytics", "Intercom", "$http", "$location", "Profile"];

  angular.
  module('gplans.layout.controllers').
  controller('ComebackController', ComebackController);

  ComebackController.$inject = ['$rootScope', '$state', '$stateParams', 'Authentication', '$window', '$analytics',
  'Intercom', '$http', '$location', 'Profile'];

  /**
                                                * @namespace ComebackController
                                                */
  function ComebackController($rootScope, $state, $stateParams, Authentication, $window, $analytics, Intercom, $http, $location, Profile) {
    var vm = this;
    try {
      var state = JSON.parse(atob($stateParams.url));
      var token = state.token;
    } catch (err) {
      var token = false;
    }
    var unregister;

    function getPlan() {
      var req = $http({
        url: gplansConf.API_URL + '/api/v1/plans/pro/',
        method: "GET",
        params: $location.search() });

      return req;
    }

    activate();

    function activate() {
      getPlan().then(function (res) {
        var newRetargetingPage = true; // false = comeback to prev state, true = comeback to payment directly
        if (newRetargetingPage && !state.state) {
          //$state.go('comeback-retargeting');
          var url = $location.url();
          var url_splitted = url.split('?');
          if (url_splitted.length >= 2) {
            var get_params = url_splitted[1];
          } else
          {
            var get_params = '';
          }
          //$state.go('base.store_payment_before_quiz');
          var baseHref = jQuery('base').prop('href').replace('dash/', '');
          Authentication.setToken(token);
          Authentication.check().then(function (res) {
            location.href = baseHref + 'retarget?' + get_params;
          });
        } else {
          Authentication.setToken(token);
          Authentication.check().then(function (res) {
            if (state.state) {
              try {
                $state.go(state.state, state.params);
              }
              catch (err) {
                $state.go('gplans.userConsole', {});
              }
            } else
            {
              $state.go('gplans.userConsole', {});
              /*
                                                    Profile.getMisc('lastViewedPage').then(
                                                    function(result){
                                                    var state = JSON.parse(result.data.value);
                                                    try {
                                                    $state.go(state.state, state.params);
                                                    }
                                                    catch (err){
                                                    $state.go('gplans.userConsole', {});
                                                    }
                                                    },
                                                    function(){
                                                    $state.go('gplans.userConsole', {});
                                                    }
                                                    );
                                                    */
            }
            // Intercom.bootOrUpdate(UserService.data); // we've already booted in app.controller
          },
          function (err) {
            $state.go('login', {});
          });


          unregister = $rootScope.$watch(function () {
            return $window.Intercom && $window.Intercom.booted;
          }, function (newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              unregister();
              $analytics.eventTrack("Came back");
              $analytics.eventTrack("Come back to state: " + state.state);
            }
          });
        }
      });
    }
  }
})();